import { Link } from 'react-router-dom';

const platforms = [
  { name: 'Amazon', color: '#FF9900', share: '38%' },
  { name: 'Etsy', color: '#F56400', share: '22%' },
  { name: 'eBay', color: '#E53238', share: '17%' },
  { name: 'AliExpress', color: '#FF4747', share: '11%' },
  { name: 'Zalando', color: '#FF6000', share: '7%' },
  { name: 'Diğerleri', color: 'rgba(255,255,255,0.3)', share: '5%' },
];

const steps = [
  { n: '01', icon: 'ri-shopping-bag-line', t: 'Sipariş Alın', d: 'Marketplace siparişi otomatik sisteme düşer.' },
  { n: '02', icon: 'ri-cpu-line', t: 'AI İşler', d: 'Sistem en iyi rota ve fiyatı anında hesaplar.' },
  { n: '03', icon: 'ri-truck-line', t: 'Kargo Yola Çıkar', d: 'Paketleme ve gümrük işlemleri tamamlanır.' },
  { n: '04', icon: 'ri-map-pin-2-line', t: 'Kapıya Teslim', d: 'Alıcı paketi teslim alır, siz büyürsünüz.' },
];

export default function MarketplacesSection() {
  return (
    <section
      className="relative overflow-hidden"
      style={{ background: 'var(--bg2)', padding: '100px 0', borderTop: '1px solid var(--border)' }}
    >
      <div className="absolute pointer-events-none" style={{ bottom: '10%', left: '-5%', width: 450, height: 450, background: 'radial-gradient(circle, rgba(232,97,26,0.07) 0%, transparent 65%)', borderRadius: '50%' }}></div>

      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* LEFT */}
          <div>
            <div className="label"><div className="label-dot"></div>E-Ticaret Entegrasyonu</div>
            <h2
              className="reveal h-font"
              style={{ fontFamily: 'var(--font-h)', fontWeight: 800, fontSize: 'clamp(36px, 4.5vw, 56px)', color: 'var(--text1)', lineHeight: 1.1, marginBottom: 20 }}
            >
              Dünyanın Büyük<br />
              <span className="text-gradient">Pazaryerlerine</span><br />
              Kapı Açın.
            </h2>
            <p className="reveal d2" style={{ color: 'var(--text2)', fontSize: 16, lineHeight: 1.7, maxWidth: 420, marginBottom: 40 }}>
              CargoNet API entegrasyonuyla Amazon, Etsy ve 50+ marketplace&apos;te sattığınız ürünler
              otomatik kargoya verilir.
            </p>

            <div className="space-y-4" style={{ marginBottom: 40 }}>
              {steps.map((s, i) => (
                <div key={s.n} className={`reveal d${i + 1} flex items-start gap-4`}>
                  <div
                    className="flex-shrink-0 w-10 h-10 flex items-center justify-center rounded-xl"
                    style={{ background: 'rgba(232,97,26,0.12)', border: '1px solid rgba(232,97,26,0.2)' }}
                  >
                    <i className={`${s.icon} text-[#E8611A]`}></i>
                  </div>
                  <div>
                    <div className="flex items-center gap-2 mb-0.5">
                      <span style={{ fontSize: 11, fontWeight: 700, color: 'var(--orange)' }}>{s.n}</span>
                      <span style={{ fontWeight: 700, fontSize: 14, color: 'var(--text1)' }}>{s.t}</span>
                    </div>
                    <p style={{ fontSize: 13, color: 'var(--text3)', lineHeight: 1.5 }}>{s.d}</p>
                  </div>
                </div>
              ))}
            </div>

            <Link to="/hizmetler" className="btn-primary">
              E-Ticaret Hizmetini İncele <i className="ri-arrow-right-line bounce-x"></i>
            </Link>
          </div>

          {/* RIGHT */}
          <div className="reveal-r">
            <div className="relative">
              <div className="relative rounded-3xl overflow-hidden" style={{ aspectRatio: '1/1', border: '1px solid rgba(232,97,26,0.25)', boxShadow: '0 0 40px rgba(232,97,26,0.12)' }}>
                <img
                  src="https://public.readdy.ai/ai/img_res/edited_2b413e6f95dc4954601fb29ae380d4e9_3c9ee53e.jpg"
                  alt="Marketplace Integration"
                  className="w-full h-full object-cover object-center"
                />

              </div>

              {/* Orbit elements */}
              <div className="absolute" style={{ top: '50%', left: '50%', width: 1, height: 1 }}>
                {platforms.slice(0, 5).map((p, i) => (
                  <div
                    key={p.name}
                    className="absolute"
                    style={{
                      width: 44, height: 44,
                      marginLeft: -22, marginTop: -22,
                      animation: `orbit${i < 2 ? '' : i < 4 ? '2' : '3'} ${14 + i * 3}s linear infinite`,
                    }}
                  >
                    <div
                      className="w-full h-full flex items-center justify-center rounded-full glass"
                      style={{ boxShadow: `0 0 16px ${p.color}44`, border: `1px solid ${p.color}44` }}
                    >
                      <span style={{ fontSize: 9, fontWeight: 800, color: p.color }}>{p.name.slice(0, 3)}</span>
                    </div>
                  </div>
                ))}
              </div>

              {/* Platforms list */}
              <div className="glass absolute bottom-4 right-4 p-4 rounded-2xl" style={{ minWidth: 180 }}>
                <p style={{ fontSize: 10, fontWeight: 700, color: 'var(--text3)', letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: 10 }}>Platform Dağılımı</p>
                {platforms.map((p) => (
                  <div key={p.name} className="flex items-center justify-between mb-2">
                    <span style={{ fontSize: 12, color: 'var(--text2)', fontWeight: 600 }}>{p.name}</span>
                    <span style={{ fontSize: 12, fontWeight: 700, color: p.color }}>{p.share}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
